import React, { useState, useEffect } from "react";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./InsertPage.css";
import Header from "../../components/header/Header";
import Button from "../../components/button/Button.js";
import "../../components/dynamicForm/constants/constants.css";
import defaultValues from "../../helpers/defaultValuesForm";
import { apiUrl } from "../../constants";
import Form from "../../components/dynamicForm/form/Form";
import removeSpacesFromUrl from "../../helpers/removeSpacesFromUrl";

const InsertPage = () => {
  const [sidebarDownloads, setSidebarDownloads] = useState(false);
  const [sidebarPreviews, setSidebarPreviews] = useState(false);
  const [sidebarExtraSearchOptions, setsidebarExtraSearchOptions] =
    useState(false);
  const [overlayActive, setOverlayActive] = useState(false);
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [success, toggleSuccess] = useState(false);
  const [positionButton, setPositionButton] = useState(1);
  const [insertedId, setInsertedId] = useState("");
  const [active, setActive] = useState("");
  const [titleSpecsheetURL, setTitleSpecsheetUrl] = useState("");
  const [titleTemplate, setTitleTemplate] = useState("");

  // The manageCreatives is an object next tot the form that is used to show and hide buttons to help display the form. This object is updated on button clicks but also when getting the data from the database and fill it in the form.
  const [manageCreatives, setManageCreatives] = useState([
    {
      creative: 1,
      adPositions: [
        {
          position: positionButton,
          positionsList: [{ title: 1 }],
        },
      ],
    },
  ]);

  const showNavigation = true;

  const { control, register, handleSubmit, errors } = useForm({
    defaultValues,
  });

  // Here we reset the success when (re)loading the page.
  useEffect(() => {
    async function resetSuccess() {
      toggleSuccess(false);
    }
    resetSuccess();
  }, []);

  // Here we check the token and if valid we insert a new specsheet. We save the result so we can show the inserted specsheet.
  async function onSubmit(data) {
    const jwtToken = localStorage.getItem("token");
    toggleErrorMessage(false);
    try {
      const result = await axios.post(
        `${apiUrl}/specsheets/specsheet`,
        {
          specsheet: data,
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      setInsertedId(result.data.insertedId);
      setActive(result.data.active);
      setTitleTemplate(result.data.templateName);
      toggleSuccess(true);
    } catch (e) {
      console.error(e);
      toggleErrorMessage(true);
    }
  }

  // This is the gray overlay behind the sidebars and will deactivate the sidebars on click
  const resetOverlay = () => {
    setOverlayActive(false);
    setSidebarPreviews(false);
    setSidebarDownloads(false);
    setsidebarExtraSearchOptions(false);
  };

  // This will show or hide the downloads sidebar
  const showSidebarDownloads = () => {
    setSidebarDownloads(!sidebarDownloads);
    setOverlayActive(!overlayActive);
  };

  // This will show or hide the keywords sidebar
  const showSidebarExtraSearchOptions = () => {
    setsidebarExtraSearchOptions(!sidebarExtraSearchOptions);
    setOverlayActive(!overlayActive);
  };

  // This will show or hide the previews sidebar
  const showSidebarPreviews = () => {
    setSidebarPreviews(!sidebarPreviews);
    setOverlayActive(!overlayActive);
  };

  // Here we set the name of the specsheet to be displayed in the url
  useEffect(() => {
    setTitleSpecsheetUrl(removeSpacesFromUrl(titleTemplate));
  }, [titleTemplate]);

  return (
    <div>
      <Header showNavigation={showNavigation} />

      {!success && (
        <div className="insert-form-outside-container">
          <div className="insert-form-container">
            <div className="specsheet-form">
              <div className="form-introduction-wrapper">
                <h1>Insert specsheet form</h1>
                <p>All fields marked with a * are required</p>
              </div>
              <form className="insert-form" onSubmit={handleSubmit(onSubmit)}>
                <Form
                  {...{
                    control,
                    register,
                    errors,
                    showSidebarDownloads,
                    showSidebarExtraSearchOptions,
                    showSidebarPreviews,
                    sidebarExtraSearchOptions,
                    sidebarPreviews,
                    sidebarDownloads,
                    setOverlayActive,
                    errorMessage,
                    manageCreatives,
                    setManageCreatives,
                    positionButton,
                    setPositionButton,
                  }}
                />

                <div className="submit-button-wrapper">
                  <section className="submit-button-section">
                    <Button type="submit">SUBMIT FORM</Button>
                  </section>
                </div>
              </form>
            </div>
          </div>
          <div
            className={overlayActive ? "overlay-visible" : "overlay"}
            onClick={resetOverlay}
          ></div>
        </div>
      )}

      {success && (
        <div className="insert-success">
          <p>The specsheet is inserted into the database.</p>

          <NavLink
            to={`/specsheet/${active}/${insertedId}/${titleSpecsheetURL}`}
          >
            <Button>Show inserted specsheet</Button>
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default InsertPage;
